/* HCC storefront: blank space, then a once-only spring reveal.
 * JS installs hiding only after IntersectionObserver is ready. No-JS stays visible.
 * Rollback: remove the hcc-spring-pop.js include from theme.liquid.
 */
;(() => {
  if (window.__hccSpringPopInstalled) return;
  window.__hccSpringPopInstalled = true;
  const selector = '[data-hcc-pop-target]';
  if (/^\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname)) return;
  const main = document.getElementById('MainContent');
  if (!main) return;
  function targets() {
    const home = main.querySelector('[data-hcc-home]');
    if (home) {
      home.querySelectorAll(':scope > section:not(.hero)').forEach(el=>el.setAttribute('data-hcc-pop-target',''));
      return [...home.querySelectorAll(selector)];
    }
    const candidates = new Set();
    const sections = [...main.children].filter(el=>el.classList.contains('shopify-section'));
    const protectedContent = 'facet-filters-form,cart-items,.cart__items,.product__info-container,product-info,form[action*="/contact"]';
    sections.slice(1).forEach(el=>{
      if (!el.querySelector(protectedContent) && !/product-grid/.test(el.id)) candidates.add(el);
    });
    main.querySelectorAll('#product-grid > .grid__item').forEach(el=>candidates.add(el));
    const first = sections[0];
    if (first) {
      first.querySelectorAll('section').forEach(el=>{
        if (!el.querySelector('h1') && !el.querySelector(protectedContent) && !/hero/i.test(el.className)) candidates.add(el);
      });
      first.querySelectorAll('.rte').forEach(rte=>{
        if (/^(H[1-6]|P|SPAN)$/.test(rte.tagName) || rte.closest('form,dialog,quick-add-modal')) return;
        if (rte.querySelector('section')) return;
        [...rte.children].forEach(el=>{
          if (!/^(SCRIPT|STYLE|LINK|H1|HR|BR)$/.test(el.tagName) && !el.querySelector(protectedContent)) candidates.add(el);
        });
      });
      first.querySelectorAll('article').forEach(el=>{
        if (!el.querySelector('h1') && !el.querySelector('form')) candidates.add(el);
      });
    }
    const list=[...candidates].filter(el=>!el.closest('dialog,quick-add-modal,form,details:not([open])'));
    list.filter(el=>!list.some(parent=>parent!==el&&parent.contains(el))).forEach(el=>el.setAttribute('data-hcc-pop-target',''));
    return [...main.querySelectorAll(selector)];
  }
  const settings = {
    desktop: { duration: 700, rise: 100, scale: .975, overshoot: -4, peak: 1.006 },
    mobile: { duration: 560, rise: 60, scale: .985, overshoot: -3, peak: 1.004 },
    viewportTrigger: .88
  };
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const seen = new WeakSet(), pending = new Set(), running = new Map();
  let observer, watchdog;
  const style = document.createElement('style');
  style.id = 'hcc-spring-pop-boundary';
  style.textContent =     '#MainContent.hcc-spring-scope{overflow-x:clip}' +
    '#MainContent .hcc-pop-pending{opacity:0;transform:translateY(100px) scale(.975);pointer-events:none}' +
    '@media(max-width:749px){#MainContent .hcc-pop-pending{transform:translateY(60px) scale(.985)}}' +
    '@media(prefers-reduced-motion:reduce){#MainContent .hcc-pop-pending{opacity:1!important;transform:none!important;pointer-events:auto!important}}';
  document.head.append(style);

  function finish(section) {
    seen.add(section);
    pending.delete(section);
    if (observer) observer.unobserve(section);
    section.classList.remove('hcc-pop-pending');
    const animation = running.get(section);
    if (animation) animation.cancel();
    running.delete(section);
  }
  function reveal(section, animate = true) {
    if (seen.has(section)) return;
    const bounds = section.getBoundingClientRect();
    finish(section);
    if (!animate || reduced.matches || bounds.bottom <= 0 || document.hidden || section.contains(document.activeElement)) return;
    const s = mobile.matches ? settings.mobile : settings.desktop;
    try {
      const animation = section.animate([
        {opacity:0,transform:'translateY('+s.rise+'px) scale('+s.scale+')',offset:0,easing:'cubic-bezier(.16,.7,.25,1)'},
        {opacity:1,transform:'translateY('+s.overshoot+'px) scale('+s.peak+')',offset:.68,easing:'cubic-bezier(.35,0,.35,1)'},
        {opacity:1,transform:'translateY(0) scale(1)',offset:1}
      ], {duration:s.duration,iterations:1,fill:'none'});
      running.set(section,animation);
      animation.onfinish = animation.oncancel = () => running.delete(section);
    } catch (_) { finish(section); }
  }
  function failOpen() {
    [...pending,...running.keys()].forEach(section=>finish(section));
    if (watchdog) {clearInterval(watchdog);watchdog=null;}
  }
  function checkViewport() {
    try {
      pending.forEach(section=>{
        if (!section.isConnected) {finish(section);return;}
        const bounds=section.getBoundingClientRect();
        if (reduced.matches || bounds.bottom<=0) reveal(section,false);
        else if (bounds.top < innerHeight*settings.viewportTrigger) reveal(section);
      });
      if (!pending.size && watchdog) {clearInterval(watchdog);watchdog=null;}
    } catch (_) {failOpen();}
  }
  function init() {
    try {
      if (!observer) observer=new IntersectionObserver(entries=>{
        try {entries.forEach(entry=>{if(entry.isIntersecting)reveal(entry.target);});}
        catch (_) {failOpen();}
      },{threshold:0,rootMargin:'0px 0px -12% 0px'});
      targets().forEach(section=>{
        if (seen.has(section)||pending.has(section))return;
        if (reduced.matches || section.getBoundingClientRect().bottom<=0 || section.contains(document.activeElement)) {finish(section);return;}
        main.classList.add('hcc-spring-scope');
        if (!main.querySelector('[data-hcc-home]') && section.getBoundingClientRect().top < innerHeight*settings.viewportTrigger) {finish(section);return;}
        pending.add(section);
        observer.observe(section);
        section.classList.add('hcc-pop-pending');
      });
      // Independent viewport check recovers missed intersections during rapid scrolls and image resizing.
      if (pending.size&&!watchdog)watchdog=setInterval(checkViewport,250);
    } catch (_) {failOpen();}
  }
  let reloadTimer;
  const updates=new MutationObserver(records=>{
    if (!records.some(record=>record.addedNodes.length)) return;
    clearTimeout(reloadTimer);reloadTimer=setTimeout(init,120);
  });
  updates.observe(main,{childList:true,subtree:true});
  function revealHash() {
    if (!location.hash) return;
    let target;
    try {target=document.getElementById(decodeURIComponent(location.hash.slice(1)));}catch(_){return;}
    if (!target) return;
    const parent=target.closest(selector);if(parent)finish(parent);
    target.querySelectorAll(selector).forEach(el=>finish(el));
  }
  window.addEventListener('hashchange',revealHash);
  document.addEventListener('focusin',event=>{
    const section=event.target.closest&&event.target.closest(selector);
    if(section)finish(section);
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{
    [...pending,...running.keys()].forEach(section=>{if(event.target.contains(section))finish(section);});
  });
  document.addEventListener('shopify:section:select',event=>{
    event.target.querySelectorAll(selector).forEach(section=>finish(section));
  });
  reduced.addEventListener('change',()=>{if(reduced.matches)failOpen();else init();});
  window.addEventListener('pageshow',event=>{if(event.persisted)failOpen();});
  window.addEventListener('pagehide',failOpen);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{init();revealHash();},{once:true});else {init();revealHash();}
})();
